import React from 'react';
import PropTypes from 'prop-types';
import { KidsDropdownSelector } from './KidsDropdownDesktop';
import { KidsDropdownNative } from './KidsDropdownMobile';

export const KidsDropdown = ({ value, onSelectKidAge, showKidError, isNative, kidsAgeRange }) => {
    let dropDown;
    if (isNative) {
        dropDown = <KidsDropdownNative value={value} onSelectKidAge={onSelectKidAge} showKidError={showKidError} list={kidsAgeRange} />;
    } else {
        dropDown = <KidsDropdownSelector value={value} onSelectKidAge={onSelectKidAge} showKidError={showKidError} list={kidsAgeRange} />;
    }
    return (dropDown);
};

KidsDropdown.propTypes = {
    value: PropTypes.number.isRequired,
    onSelectKidAge: PropTypes.func.isRequired,
    isNative: PropTypes.bool,
    showKidError: PropTypes.bool,
    kidsAgeRange: PropTypes.arrayOf(PropTypes.number)
};

KidsDropdown.defaultProps = {
    showKidError: false,
    isNative: false,
};
